import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BackButton from '../../components/BackButton';
import { useTheme } from '../../contexts/ThemeContext';
import { useAuth } from '../../contexts/AuthContext';

function Login() {
    const navigate = useNavigate();
    const { theme } = useTheme();
    const { login, isLoading } = useAuth();

    const [handle, setHandle] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const isMobile = window.innerWidth <= 768;

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError('');

        if (!handle.trim() || !password) {
            setError('Enter your handle and password.');
            return;
        }

        try {
            setSubmitting(true);
            await login({
                handle: handle.trim(),
                password,
            });
            navigate('/');
        } catch (requestError) {
            setError(requestError.message || 'Login failed');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div style={{
            minHeight: '100vh',
            backgroundColor: theme.bgMedium,
            color: theme.textPrimary,
            padding: isMobile ? '16px' : '24px',
        }}>
            <BackButton to="/" />
            <div style={{
                maxWidth: '520px',
                margin: '80px auto 0',
                backgroundColor: theme.bgDark,
                border: `2px solid ${theme.secondary}`,
                borderRadius: '12px',
                padding: isMobile ? '16px' : '24px',
            }}>
                <h1 style={{ marginTop: 0 }}>Sign In</h1>
                <p style={{ marginTop: 0, color: theme.textSecondary }}>
                    Sign in with your handle. No personal profile data required.
                </p>

                <form onSubmit={handleSubmit} style={{ display: 'grid', gap: '12px' }}>
                    <label style={{ display: 'grid', gap: '8px' }}>
                        <span>Handle</span>
                        <input
                            value={handle}
                            onChange={(e) => setHandle(e.target.value)}
                            autoComplete="username"
                            placeholder="player_one"
                            style={{
                                padding: '12px',
                                borderRadius: '8px',
                                border: `2px solid ${theme.secondary}`,
                                backgroundColor: theme.bgMedium,
                                color: theme.textPrimary,
                                fontFamily: 'inherit',
                            }}
                        />
                    </label>

                    <label style={{ display: 'grid', gap: '8px' }}>
                        <span>Password</span>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            autoComplete="current-password"
                            style={{
                                padding: '12px',
                                borderRadius: '8px',
                                border: `2px solid ${theme.secondary}`,
                                backgroundColor: theme.bgMedium,
                                color: theme.textPrimary,
                                fontFamily: 'inherit',
                            }}
                        />
                    </label>

                    {error && (
                        <div style={{ color: theme.danger }}>{error}</div>
                    )}

                    <button
                        type="submit"
                        disabled={submitting || isLoading}
                        style={{
                            padding: '12px 16px',
                            borderRadius: '8px',
                            border: 'none',
                            backgroundColor: theme.accent,
                            color: theme.textPrimary,
                            fontFamily: 'inherit',
                            fontWeight: 'bold',
                            cursor: submitting || isLoading ? 'not-allowed' : 'pointer',
                            opacity: submitting || isLoading ? 0.7 : 1,
                        }}
                    >
                        {submitting ? 'Signing In...' : 'Sign In'}
                    </button>
                </form>

                <button
                    onClick={() => navigate('/register')}
                    style={{
                        marginTop: '12px',
                        background: 'none',
                        border: 'none',
                        color: theme.accent,
                        cursor: 'pointer',
                        textDecoration: 'underline',
                        padding: 0,
                    }}
                >
                    Need an account? Create one.
                </button>
            </div>
        </div>
    );
}

export default Login;
